export default __webpack_public_path__ + "static/media/Jira.8f1679e7.svg";